import dynamic from 'next/dynamic';
import withCustomErrorBoundary from '@components/HOC/withCustomErrorBoundary';
import DefaultLayout from '@components/layouts/DefaultLayout';
import getPageErrorProps from '@utils/getPageErrorProps';
import getServerSideTranslations from '@utils/getServerSideTranslations';
import TAB_SLUGS from '@constants/tabSlugs';
import { getCookie } from 'cookies-next';

const NewOrderCreatePage = dynamic(
  () =>
    import('@views/NewOrder/NewOrderCreatePage/NewOrderCreatePage.container'),
  {
    ssr: false,
    loading: () => null,
  }
);

const UNAUTHORIZED_STEPS = [TAB_SLUGS.SUMMARY, TAB_SLUGS.DELIVERY_DATA];

export const getServerSideProps = async ({
  req,
  res,
  query,
  resolvedUrl,
  locale,
}) => {
  const token = getCookie('token', { req, res });

  if (
    UNAUTHORIZED_STEPS.includes(query.step) &&
    !!query.basketId &&
    !token &&
    !res?.headersSent
  ) {
    const protocol = req.headers['x-forwarded-proto'] || 'https';
    const { host } = req.headers;
    const baseUrl = `${protocol}://${host}`;
    const urlObj = new URL(resolvedUrl, baseUrl);

    urlObj.searchParams.set('step', TAB_SLUGS.AUTHORIZATION);

    return {
      redirect: {
        destination: urlObj.pathname + urlObj.search,
        permanent: false,
      },
    };
  }

  try {
    return {
      props: {
        ...(await getServerSideTranslations(locale)),
        bodyClassName: 'page--new-order',
        locale,
      },
    };
  } catch (error) {
    return await getPageErrorProps({ error, locale });
  }
};

const LayoutWithProps = ({ children }) => {
  const styles = { content: { mode: 'replace', css: null } };

  return <DefaultLayout styles={styles}>{children}</DefaultLayout>;
};

const ComponentWithHoc = withCustomErrorBoundary(NewOrderCreatePage);
ComponentWithHoc.Layout = LayoutWithProps;

export default ComponentWithHoc;
